/**
 * Human-readable message shown in tooltips and disabled-state UI when a feature
 * is blocked by the current scope. Exported so all consumers use the same string.
 */
export const NOT_SUPPORTED_IN_SCOPE_MESSAGE = 'Not supported in current scope';
